import { render } from "./AgregarRecetaStepper.vue?vue&type=template&id=96eb1f8c"
import script from "./AgregarRecetaStepper.vue?vue&type=script&lang=js"
export * from "./AgregarRecetaStepper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__